module.exports = __webpack_public_path__ + "img/MaskGroup.12ffc4e6.png";